import { CDN_URL_ICONS } from '@/configs';
import CPlayerShare from '@/contracts';
import CPassToken from '@/contracts/passToken';
import { IGetPlayerPoolProfile } from '@/interfaces/api/player-share';
import ListProposal from '@/layouts/AlphaLayout/CircleTreasury/TreasuryDetail/TreasuryProposal/ListProposal';
import { PROPOSAL_NOT_CREATE_MODAL_NAME } from '@/modules/AlphaPWA/DirectMessage/Chat/Proposal/constants';
import CreateModal from '@/modules/AlphaPWA/DirectMessage/Chat/Proposal/CreateModal';
import { getPlayerPoolProfile } from '@/services/player-share';
import { selectCommonReducer } from '@/state/common';
import { closeModal, openModal } from '@/state/modal';
import {
  Box,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from '@chakra-ui/react';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import s from './styles.module.scss';
import cx from 'clsx';
import useTradeKey from '@/hooks/playerShareToken/useTradeKey';

const TreasuryProposal = ({ profile }: any) => {
  const dispatch = useDispatch();
  const needReload = useSelector(selectCommonReducer).needReload;

  const cplayerShare = new CPlayerShare();
  const passToken = useRef(new CPassToken()).current;

  const [ownerProfile, setOwnerProfile] = useState<IGetPlayerPoolProfile>();
  const [balanceToken, setBalanceToken] = useState('0');
  const [circleTreasury, setCircleTreasury] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  const { userProfile } = useTradeKey();

  const allowCreate = useMemo(() => {
    return Number(balanceToken) >= 1;
  }, [balanceToken]);

  useEffect(() => {
    if (profile) {
      fetchTreasury();
    }
  }, [profile, needReload]);

  const fetchTreasury = async () => {
    try {
      const [player, balance, treasury] = await Promise.all([
        getPlayerPoolProfile(profile.address),
        cplayerShare.getTokenBalance(profile.tokenAddress),
        passToken.getCircleTreasury({
          twitterId: profile.twitterId,
        }),
      ]);

      setOwnerProfile(player);
      setBalanceToken(balance);
      setCircleTreasury(treasury);
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  const onClickCreateProposal = () => {
    if (!allowCreate) {
      return;
    }

    const close = () =>
      dispatch(closeModal({ id: PROPOSAL_NOT_CREATE_MODAL_NAME }));
    dispatch(
      openModal({
        id: PROPOSAL_NOT_CREATE_MODAL_NAME,
        theme: 'dark',
        modalProps: {
          centered: true,
          zIndex: 9999999,
        },
        hideCloseButton: false,
        disableBgClose: true,
        render: () => (
          <CreateModal
            profile={ownerProfile}
            userProfile={userProfile}
            circleTreasury={circleTreasury}
            onClose={close}
          />
        ),
      })
    );
  };

  return (
    <Tabs
      className={s.tabContainer}
      isLazy
      lazyBehavior="keepMounted"
      index={0}
      isFitted
    >
      <TabList>
        <Tab>
          <span>Proposals</span>
        </Tab>
        <Box
          className={cx(s.buttonSetup, allowCreate ? '' : s.disable)}
          onClick={onClickCreateProposal}
        >
          <img src={`${CDN_URL_ICONS}/ic-setup-01.svg`} />
          <Text>Submit Proposal</Text>
        </Box>
      </TabList>
      <TabPanels>
        <TabPanel>
          {!loading && !allowCreate && (
            <Text
              fontSize={'12px'}
              fontWeight={500}
              color={'#FF7E21 !important'}
              textAlign={'right'}
              padding={'4px 10px'}
            >
              1 key is required for proposal submission.
            </Text>
          )}
          <ListProposal profile={profile} />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};

export default TreasuryProposal;
